// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"0e1ba238dd1c66c915c3","293":"24cfcfb36cac0d4e37e9"}[chunkId] + ".js";
};